<template>
  <div>
    <header class="h_header">
      <div class="h_top v-container d-flex align-items-center">
        <div class="h_logo">
          <img src="@/assets/images/logo/logo-p2-cargo.webp" alt="logo" title="anan-cargo-logo" />
        </div>
      </div>
    </header>

    <main>
      <div class="bg_content">
        <div class="bg_content2 p-md-5 p-1">
          <div class="row">
            <div class="col-md-6">
              <div class="text-center text-white h-100 mt-10">
                <div>
                  <b-img src="@/assets/images/logo/logo-login.webp" alt="logo" title="anan-cargo-logo" class="w-50" />
                </div>

                <div class="mt-10 mb-10">
                  <h1 class="text-white" style="letter-spacing: 5px">
                    บริการรับนำเข้าสินค้า
                  </h1>
                  <h3 class="text-white"><span class="text-warning">จากจีนมาไทย</span> ทุกรูปแบบ</h3>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="bg-login">
                <div class="mb-2">
                  <h2>เปลี่ยนรหัสผ่าน</h2>
                </div>
                <validation-observer ref="changePasswordValidation">
                  <div>
                    <!-- current password -->
                    <b-form-group label="รหัสผ่านปัจจุบัน" label-for="current-password">
                      <validation-provider #default="{ errors }" name="Current Password" rules="required">
                        <b-form-input
                          id="current-password"
                          v-model="currentPassword"
                          :state="errors.length > 0 ? false : null"
                          class="form-control-merge"
                          :type="passwordFieldType"
                          name="current-password"
                          placeholder="••••••••••••"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group label="รหัสผ่านใหม่" label-for="rg-password">
                      <validation-provider #default="{ errors }" name="Password" rules="required">
                        <b-form-input
                          id="rg-password"
                          v-model="password"
                          :state="errors.length > 0 ? false : null"
                          class="form-control-merge"
                          :type="passwordFieldType"
                          name="login-password"
                          placeholder="············"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group label="ยืนยันรหัสผ่านใหม่" label-for="rg-password-confirm">
                      <validation-provider #default="{ errors }" name="Password Confirm" rules="required|confirmed:Password">
                        <b-form-input
                          v-model="passwordCon"
                          :state="errors.length > 0 ? false : null"
                          type="password"
                          placeholder="Confirm Password"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-button type="submit" variant="primary" block size="lg" :disabled="isDisabled" @click="confirmData()">
                      ยืนยัน
                    </b-button>
                  </div>
                </validation-observer>

                <b-row>
                  <b-col cols="12" class="text-center mt-2">
                    <span>
                      <router-link class="text-primary ms-2 mb-1 font-weight-bolder" :to="{ name: 'dashboard' }">
                        กลับสู่หน้าหลัก
                      </router-link>
                    </span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <this-footer />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BButton,
  BImg,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ThisFooter from './component/ThisFooter.vue'

export default {
  components: {
    ThisFooter,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BImg,
    BForm,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      required,
      currentPassword: null,
      password: null,
      passwordCon: null,
      isDisabled: false,
      username: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        const { data: res } = await this.$http.get('/Profilecustomer/show')
        this.username = res.username
      } catch (e) {
        console.log(e)
      }
    },
    confirmData() {
      this.isDisabled = true
      this.$refs.changePasswordValidation.validate().then(success => {
        if (success) {
          if (this.password !== this.passwordCon) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'รหัสผ่านไม่ตรงกัน',
                icon: 'EditIcon',
                variant: 'warning',
              },
            })
            this.isDisabled = false
          } else {
            const obj = {
              password: this.password,
              currentPassword: this.currentPassword,
            }
            this.$http.post('/users/UpdatePass', obj)
              .then(response => {
                if (response.data.status) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'เปลี่ยนรหัสผ่านสำเร็จ',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: 'คุณได้ทำการเปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
                    },
                  })
                  setTimeout(() => {
                    this.$router.push('/')
                  }, 1000)
                } else {
                  this.SwalError(response.data.message || 'เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน')
                  this.isDisabled = false
                }
              })
              .catch(err => {
                this.SwalError(err.response.data.message || 'เกิดข้อผิดพลาด')
                console.log(err)
                this.isDisabled = false
              })
          }
        } else {
          this.isDisabled = false
        }
      })
    },
    SwalError(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        confirmButtonText: 'Cool',
      })
    },
  },
}
</script>

<style scoped>
</style>
